import React from 'react';
import '../Styles/styles.css';

const DocAssistProduct = () => {
    return (
        <section className="container">
            <div className="section-title">
                <h2 >Doc Assist</h2>
            </div>
            <div className="text-center">
                <p className="text-muted">For Gynaecologists and Obstetricians</p>
            </div>
            <div>
                <p>
                    Software products targeted at the medical profession very often deal with aspects such as billing,
                    hospital bed management, inventories and do not always have a direct effect on the quality of care
                    a doctor is able to provide to the patient. Despite the introduction of software systems, doctors
                    spend significant amount of time, physically writing case histories and very often case histories
                    of patients are not readily available because they have either been put away in storage or they are
                    simply lost.
                </p>
                <p>
                    Doc Assist is a software product that has been developed to specifically address this issue.
                    Doc Assist is targeted specifically at gynecologists and obstetricians. This has evolved over
                    a period of years based on extensive interaction with a very reputed gynecologist in Bangalore,
                    India.
                </p>
            </div>
            <div>
                <div>
                    <h5>1. Administration</h5>
                    <ul>
                        <li>Patient Registration</li>
                        <li>Appointments</li>
                    </ul>
                </div>
                <div>
                    <h5>2. Gynaecology and Obstetrics</h5>
                    <ul>
                        <li>Gynecology</li>
                        <li>Obstetrics</li>
                        <li>General Medical Record</li>
                        <li>Infertility</li>
                    </ul>
                </div>
                <div>
                    <h5>3. Surgical, Scans and Laboratory</h5>
                    <ul>
                        <li>Pregnancy Scan</li>
                        <li>Operation reports</li>
                        <li>Discharge Notes</li>
                        <li>Laboratory
                        </li>
                    </ul>
                </div>
                <div>
                    <p>
                        The integration of Doc Assist with the document management engine, enables doctors create a
                        multimedia medical database that can consist of scanned documents (such as x-rays, old medical
                        records), video (such as ultrasound scans) and audio (e.g. conversations with patients for
                        medico-legal reasons).
                    </p>
                </div>
                <div>
                    <h5>The Doc Assist Advantage</h5>
                    <div>
                        <h5>1. To the Doctor:</h5>
                        <ul >
                            <li >Time spent on writing the patient file is reduced by nearly 95% - which means more quality time can be spent with the patient.</li>
                            <li >Your patient files are available to you at any time - all the time.</li>
                            <li >ALL information about a patient - case sheets, x-rays, ultrasound images, laboratory reports, etc., is part of the patient file.</li>
                            <li >Patient records are created online - no delay.</li>
                            <li >You will be able to cross-reference your patient files for astute medical analysis.</li>
                            <li >You can create your own personal reference database of labs, hospitals, and doctors.</li>
                            <li >You will have all your files easily accessible in case you need them for legal matters.</li>
                        </ul>

                        <h5>2. To the Patient:</h5>
                        <ul >
                            <li >Computer-generated reports eliminating any ambiguities.</li>
                            <li >On-the-spot reports eliminating the need for a repeat visit to pick up reports.</li>
                            <li >Printed prescription instructions making it clear what to take, how much to take, and when to take it.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DocAssistProduct;
